import { useAuthStore } from "@/stores/auth";

export function getUserRoles() {
  const auth = useAuthStore();
  return auth.user?.role ? [auth.user.role] : [];
}
